module.exports = __webpack_public_path__ + "fonts/Lato-BoldItalic.f98d1804.ttf";